import { TargetConfig } from "../types/TargetConfig";
import { CenterFieldDto, HitDto } from "../types/TargetScannedDataDTOs";
import { calculateDistance } from "./statsCalculation";

export const calculateScore = (
    centerFieldDTO: CenterFieldDto, 
    hitsDTOs: HitDto[], 
    targetConfig: TargetConfig, 
    hitRadius: number, 
    numberOfRatedShots: number
): string[] => {
    const scaleFactor: number = centerFieldDTO.radius / targetConfig.centerFieldRadius;

    const pointsScored: string[] = [];

    hitsDTOs.forEach((hit: HitDto) => {
        const hitDistance: number = calculateDistance(centerFieldDTO, hit) / scaleFactor - hitRadius;
        
        for (const key in targetConfig.fieldStartRadiusToScoreMap) {
            if (hitDistance < parseFloat(key)) {
                pointsScored.push(targetConfig.fieldStartRadiusToScoreMap[key]);
                break;
            }
        }
    })

    // console.log("Punkty: ", pointsScored.sort((a, b) => b - a));
    return pointsScored.sort((a, b) => parseFloat(b) - parseFloat(a)).slice(0, numberOfRatedShots);
};

export const calculateTotalScoreSum = (pointsScored: string[]): number => {
    return pointsScored.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue), 0);
}
